(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Sort: reload the collection with the chosen order, keeping filters
    document.addEventListener('change', (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('[data-ofc-sort]')) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    // Filters panel: close when clicking outside or pressing Escape
    const closeAll = (except) => {
      document.querySelectorAll('details[data-ofc-more][open]').forEach((details) => {
        if (details !== except) details.removeAttribute('open');
      });
    };
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      closeAll(target?.closest('details[data-ofc-more]'));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll(null);
    });

    // Filters panel: open towards whichever side has room (the button can wrap to the left
    // when there are many pills)
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.matches('[data-ofc-more]') || !details.open) return;
        const panel = details.querySelector('.ofc-panel');
        if (!(panel instanceof HTMLElement) || window.matchMedia('(max-width: 749px)').matches) return;
        panel.classList.remove('ofc-panel--start');
        if (panel.getBoundingClientRect().left < 8) panel.classList.add('ofc-panel--start');
      },
      true
    );

    // "Shop for my grill": remember the chosen grill and open accessory pages already filtered to it.
    // "Show everything" (or "Choose your grill") pauses this for the rest of the visit.
    const GRILL_KEY = 'ofc-my-grill';
    const PAUSE_KEY = 'ofc-my-grill-paused';
    const readStore = (type, key) => {
      try {
        return window[type].getItem(key);
      } catch (error) {
        return null;
      }
    };
    const writeStore = (type, key, value) => {
      try {
        if (value === null) window[type].removeItem(key);
        else window[type].setItem(key, value);
      } catch (error) {
        /* storage blocked - picker still works, it just isn't remembered */
      }
    };

    document.addEventListener('change', (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('[data-ofc-grill]')) return;
      if (select.value) {
        writeStore('localStorage', GRILL_KEY, select.value);
        writeStore('sessionStorage', PAUSE_KEY, null);
      } else {
        writeStore('sessionStorage', PAUSE_KEY, '1');
        select.disabled = true;
      }
      select.form?.submit();
    });

    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-ofc-grill-off]') : null;
      if (link) writeStore('sessionStorage', PAUSE_KEY, '1');
    });

    const applySavedGrill = () => {
      if (window.Shopify?.designMode) return;
      const select = document.querySelector('select[data-ofc-grill]');
      if (!(select instanceof HTMLSelectElement) || select.value) return;
      const saved = readStore('localStorage', GRILL_KEY);
      if (!saved || readStore('sessionStorage', PAUSE_KEY)) return;
      if (!Array.from(select.options).some((option) => option.value === saved)) return;
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.append(select.name, saved);
      window.location.replace(url.toString());
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applySavedGrill);
    else applySavedGrill();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-info"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-product-info')) {
    class CustomProductInfo extends HTMLElement {
      connectedCallback() {
        // Drop panels with nothing in them (e.g. Features before the metafield is filled), except in the editor
        if (!window.Shopify?.designMode) {
          this.querySelectorAll(':scope > [data-panel]').forEach((panel) => {
            const body = panel.querySelector('.custom-panel__body');
            if (body && !body.textContent.trim() && !body.querySelector('img, table, iframe, video')) panel.remove();
          });
        }

        if (this.dataset.layout !== 'tabs') return;
        const panels = [...this.querySelectorAll(':scope > [data-panel]')];
        if (!panels.length) return;

        const tablist = document.createElement('div');
        tablist.className = 'custom-product-info__tabs';
        tablist.setAttribute('role', 'tablist');
        if (this.dataset.tablistLabel) tablist.setAttribute('aria-label', this.dataset.tablistLabel);

        const tabs = panels.map((panel, index) => {
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'custom-product-info__tab';
          tab.id = `${panel.id}-tab`;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          tab.textContent = panel.querySelector('[data-panel-title]')?.textContent.trim() || `Tab ${index + 1}`;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            this.select(next);
            tabs[next].focus();
          });
          tablist.append(tab);
          return tab;
        });

        // Mobile accordion toggles
        panels.forEach((panel) => {
          const toggle = panel.querySelector('[data-panel-toggle]');
          toggle?.addEventListener('click', () => {
            if (!window.matchMedia('(max-width: 749px)').matches) return;
            const open = !panel.classList.contains('is-open');
            panel.classList.toggle('is-open', open);
            toggle.setAttribute('aria-expanded', String(open));
          });
        });

        this.panels = panels;
        this.tabs = tabs;
        this.prepend(tablist);
        this.select(0);
        panels[0].classList.add('is-open');
        panels[0].querySelector('[data-panel-toggle]')?.setAttribute('aria-expanded', 'true');
        this.toggleAttribute('data-ready', true);
      }

      /** @param {number} index */
      select(index) {
        this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
      }
    }
    customElements.define('custom-product-info', CustomProductInfo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-promo-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-promo-bar')) {
    class CustomPromoBar extends HTMLElement {
      connectedCallback() {
        const key = this.dataset.dismissKey;
        if (!key) return;

        try {
          if (sessionStorage.getItem(key) === '1' && !window.Shopify?.designMode) this.hidden = true;
        } catch (error) {}

        this.querySelector('[data-dismiss]')?.addEventListener('click', () => {
          this.hidden = true;
          try {
            sessionStorage.setItem(key, '1');
          } catch (error) {}
        });
      }
    }

    customElements.define('custom-promo-bar', CustomPromoBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
